/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import SkeletonBox from "./components/SkeletonBox";

require('babel-polyfill');
require('./bootstrap');

window.Vue = require('vue');


/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */


import BootstrapVue from 'bootstrap-vue'
import VueCurrencyFilter from 'vue-currency-filter'
import NetPriceFilters from './filters/NetPriceFilters';
import VueTruncate from './filters/TruncateFilter';
import QuantityPlural from "./filters/QuantityPlural";
import OpenLinkDirective from "./directives/OpenLinkDirective";
import {NoticeService} from "./services/NoticeService";
import {FilterService} from "./services/FilterService";
import {QuantityService} from "./services/QuantityService";
import {ShoppingCartService} from "./services/ShoppingCartService";
import {CheckoutService} from "./services/CheckoutService";
import {StockService} from "./services/StockService";
import {CompareService} from "./services/CompareService";
import {VideoCarousel} from "./carousel/Video";
import {LazyCarousel} from "./carousel/Lazy";
import VueCookie from 'vue-cookie';
import VueScrollTo from 'vue-scrollto';
import VueSticky from 'vue-sticky';
import datePicker from 'vue-bootstrap-datetimepicker';
import VueCookies from 'vue-cookies';
import lazyLoadComponent from "./utils/lazy-load-component";

/**
 * Object.prototype.forEach() polyfill
 * https://gomakethings.com/looping-through-objects-with-es6/
 * @author Chris Ferdinandi
 * @license MIT
 */
if (!Object.prototype.forEach) {
    Object.defineProperty(Object.prototype, 'objForEach', {
        value: function (callback, thisArg) {
            if (this === null) {
                throw new TypeError('Not an object');
            }
            thisArg = thisArg || window;
            for (let key in this) {
                if (this.hasOwnProperty(key)) {
                    callback.call(thisArg, this[key], key, this);
                }
            }
        }
    });
}


/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

const files = require.context('./', true, /\.vue$/i, 'lazy').keys();

files.forEach(file => {
    Vue.component(file.split('/').pop().split('.')[0], () => import(`${file}`));
});


// Price Tax Switch
Vue.use(VueCookie);

Vue.use(BootstrapVue);

Vue.use(datePicker);
Vue.use(VueCurrencyFilter, {
    symbol : '€',
    thousandsSeparator: '.',
    fractionCount: 2,
    fractionSeparator: ',',
    symbolPosition: 'front',
    symbolSpacing: true
});
Vue.use(VueTruncate);
Vue.use(NetPriceFilters);
Vue.use(QuantityPlural);
Vue.use(OpenLinkDirective);
Vue.use(VueScrollTo, {
    container: "body",
    duration: 500,
    easing: "ease",
    offset: -160,
    cancelable: true,
    onStart: false,
    onDone: false,
    onCancel: false,
    x: false,
    y: true
});
Vue.use(VueSticky);
Vue.use(VueCookies);

const defaultOptions = {
    loading: SkeletonBox,
    loadingData: {
        props: {
            width: `100%`,
            height: `20em`,
        },
    },
};

document.addEventListener('DOMContentLoaded', function () {

    window.QuantityService = new QuantityService();
    window.ShoppingCartService = new ShoppingCartService();
    window.CheckoutService = new CheckoutService();
    window.StockService = new StockService();
    window.FilterService = new FilterService();
    window.CompareService = new CompareService();
    window.NoticeService = new NoticeService();
    window.VideoCarousel = new VideoCarousel();
    window.LazyCarousel = new LazyCarousel();


    window.bus = new Vue({});
    const app = new Vue({
        el: '#app',
        currentView: 'app',
        directives: {
            'sticky': VueSticky,
        },
        data: {
            mobileMenuToggle: false,
            windowHeight: 0,
            windowWidth: 0
        },
        methods: {
            toggleMobileMenu: function () {
                if(this.mobileMenuToggle) {
                    this.mobileMenuToggle = false;
                } else {
                    this.mobileMenuToggle = true;
                }
            }
        },
        components: {
            LazyCategoryFilters: lazyLoadComponent({
                ...defaultOptions,
                componentFactory: () => import(`./components/CategoryFiltersComponent`),
            }),
        },
        watch: {
            windowWidth(newWidth, oldWidth) {
                if(newWidth >= 576) {
                    this.mobileMenuToggle = false;
                }
            },
            windowHeight(newHeight, oldHeight) {

            },
        },
        mounted() {
            let self = this;
            this.$nextTick(function() {
                window.addEventListener('resize', function(e) {
                    self.windowHeight = window.innerHeight;
                    self.windowWidth = window.innerWidth;
                });
            });

            let appHeader = document.getElementsByClassName("sticky-header");
            let removeZIndexModal = document.getElementsByClassName("remove-z-index-modal");
            if(typeof appHeader[0] !== 'undefined') {
                this.$root.$on('bv::modal::show', function(e) {
                    appHeader[0].style.zIndex = "40"
                });
                this.$root.$on('bv::modal::hidden', function(e) {
                    appHeader[0].style.zIndex = "51"
                });
            }

            for (let i=0; i<removeZIndexModal.length; i++) {
                this.$root.$on('bv::modal::show', function(e) {
                    removeZIndexModal[i].classList.add('z-index-0');
                });
                this.$root.$on('bv::modal::hidden', function(e) {
                    removeZIndexModal[i].classList.remove('z-index-0');
                });
            }

            /**
             * Toggle divergent rows on divergent page
             */
            var divergentButton = document.getElementsByClassName('divergent-button');

            for(let i = 0; i < divergentButton.length; i++) {
                divergentButton[i].addEventListener("click", function() {
                    let notDivergents = document.getElementsByClassName("js-not-divergent");
                    for (let key in notDivergents) {
                        if (!notDivergents.hasOwnProperty(key)) continue;
                        let notDivergent = notDivergents[key];
                        if (notDivergent.style.display === "none") {
                            notDivergent.style.display = "table-row";
                            this.innerHTML = "Toon verschillen";
                        } else {
                            notDivergent.style.display = "none";
                            this.innerHTML = "Toon alles";
                        }
                    }
                })
            }
        },
    });
});

// document.addEventListener("DOMContentLoaded", function() {
//     var lazyImages = [].slice.call(document.querySelectorAll("img.lazy-load"));
//
//     if ("IntersectionObserver" in window) {
//         let lazyImageObserver = new IntersectionObserver(function(entries, observer) {
//             entries.forEach(function(entry) {
//                 if (entry.isIntersecting) {
//                     let lazyImage = entry.target;
//                     lazyImage.src = lazyImage.dataset.src;
//                     lazyImage.classList.remove("lazy-load");
//                     lazyImageObserver.unobserve(lazyImage);
//                 }
//             });
//         });
//
//         lazyImages.forEach(function(lazyImage) {
//             lazyImageObserver.observe(lazyImage);
//         });
//     } else {
//         // Possibly fall back to a more compatible method here
//     }
// });


window.document.body.onscroll = function() {
    if(typeof document.getElementsByClassName("scrollheader")[0] !== 'undefined') {
        let scrollHeader = document.getElementsByClassName("scrollheader")[0];
        if(document.getElementsByClassName("scrollheader")[0].getBoundingClientRect().top === 0) {
            scrollHeader.classList.add('sticky');
        } else {
            scrollHeader.classList.remove('sticky');
        }
    }
};


window.onpopstate = function(event) {
    if(-1 === document.location.toString().indexOf('/products/')) {
        window.location.reload();
    }
};


window.VueApp = app;

require('./jquery/mobile-menu');
require('./jquery/order-again')
require('./jquery/gtm-product-clicks');

$(document).ready(function() {
    $(window).scroll(function(){
        if ($(window).scrollTop() >= 1) {
            $('header').addClass('shadow-header');
            $('.sticky-header').addClass('ie-fix');
        } else {
            $('header').removeClass('shadow-header');
            $('.sticky-header').removeClass('ie-fix');
        }
    });


    $('#mailShoppingCart').click(function() {
        $(this).html($(this).attr('submit-text'));
        $(this).attr("disabled", "disabled");
        $('#mailCartForm').submit();
    });

    // Notices popover toggle
    jQuery('[data-toggle=popover]').popover();

    if(window.location.hash) {
        const yOffset = -160;
        const element = document.getElementById(window.location.hash.substring(1));
        const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;

        window.scrollTo({top: y, behavior: 'smooth'});
    }


});
